import "./sp.scss";
const SPShopLayout = ({ children }) => {
  return <div className="container-main container-sp">{children}</div>;
};

export default SPShopLayout;
